export default {
    setUsers(state,payload){
        state.users = payload;
    }
}